import React, { useMemo, useState } from "react";
import { Alert, Table, Layout, Tabs, Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./SkillsManagement.scss";
import useSkillsManagement from "./logic/useSkillsManagement";
import SkillsRequestsManagement from "./components/SkillsRequestsManagement";

const SkillsManagement = () => {
  const {
    skills,
    isLoading,
    error,
    columns,
    handleAddSkill,
    searchQuery,
    setSearchQuery,
  } = useSkillsManagement();

  const [tabTitle, setTabTitle] = useState("Skills Management");

  const onTabChange = (key) => {
    switch (key) {
      case "1":
        setTabTitle("Skills Management");
        break;
      case "2":
        setTabTitle("Skills Requests Management");
        break;
      default:
        setTabTitle("Skills Management");
    }
  };

  const tabItems = useMemo(
    () => [
      {
        key: "1",
        label: `Skills Management`,
        children: (
          <div className="role-container">
            <div className="table-top-section">
              <Input.Search
                placeholder="Search ..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ width: "300px" }}
                className="search-input"
                allowClear
              />

              <Button
                onClick={handleAddSkill}
                type="primary"
                icon={<PlusOutlined />}
              >
                Add Skill
              </Button>
            </div>

            <div className="skills-content-container">
              {error ? (
                <Alert message="An error has occurred" type="error" showIcon />
              ) : (
                <Table
                  columns={columns}
                  dataSource={skills}
                  loading={isLoading}
                  pagination={{ pageSize: 10 }}
                />
              )}
            </div>
          </div>
        ),
      },
      {
        key: "2",
        label: `Skills Requests Management`,
        children: <SkillsRequestsManagement />,
      },
    ],
    [skills, isLoading, error, columns, handleAddSkill, searchQuery]
  );

  return (
    <Layout pagename={tabTitle}>
      <Tabs
        defaultActiveKey="1"
        items={tabItems}
        onChange={onTabChange}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
    </Layout>
  );
};

export default SkillsManagement;
